import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';

function Stock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        // Calculate total 
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;


        dataItem.forEach(item => {
            totalopbal += item.OpeningQty;
            totalp += item.PurchaseQty;
            totalprtn += item.PurchaseReturnQty;
            totals += item.SaleQty;
            totalsrtn += item.SaleReturnQty;
            totalstin += item.StockInQty;
            totalstout += item.StockOutQty;
            totalrpl += item.StockJournalQty; // here im using the stockjoueral data 
            totalcls += item.ClosingQty;
            totalstkval += item.StockValue;
            totalsalval += item.SaleValue;
        });
        setTotalopbal(totalopbal);
        setTotalp(totalp);
        setTotalprtn(totalprtn);
        setTotals(totals);
        setTotalsrtn(totalsrtn);
        setTotalsint(totalstin);
        setTotalstout(totalstout);
        setTotalrpl(totalrpl);
        setTotalcls(totalcls);
        setTotalstkval(totalstkval);
        setTotalsalval(totalsalval);
    }, [dataItem]);

    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            const itemId = 0;
            const branchId = 0;
            try {
                const response = await fetchData('ReportApi', `/Stock/${companyId}/${itemId}/${branchId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    const handleExportExcel = () => {
        
        const wb = XLSX.utils.book_new();

        // Create a sheet with all data (without grouping)
        const allDataSheet = [];
        const allDataHeaderCaption = [`Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        allDataSheet.push(allDataHeaderCaption);

        const headerRow = ['Category','Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock Journal', 'Closing', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code'];
        allDataSheet.push(headerRow);

        
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                rowData.CategoryName,
                rowData.Code,
                rowData.Name,
                rowData.OpeningQty,
                rowData.PurchaseQty,
                rowData.PurchaseReturnQty,
                rowData.SaleQty,
                rowData.SaleReturnQty,
                rowData.StockJournalQty,
                rowData.ClosingQty,
                parseFloat(rowData.PurchaseRate.toFixed(2)),
                parseFloat(rowData.MRP.toFixed(2)),
                rowData.GSTRate,
                rowData.HSNCode,
            ];
            allDataSheet.push(dataRow);
        });


        // Add total row for the all data sheet
        const totalRowAll = ['Total','','', totalopbal, totalp, totalprtn, totals, totalsrtn, totalrpl, totalcls];
        allDataSheet.push(totalRowAll);

        const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);
        XLSX.utils.book_append_sheet(wb, allDataWs, 'Stock');

        
        // Write the workbook to a file
        XLSX.writeFile(wb, 'Stock.xlsx');
    };



    const handlePrint = () => {

    };

    const [isFocused, setIsFocused] = useState(false);


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>
                       CONSOLIDATED STOCK
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                marginTop: '15px'
                            }}
                        />
                    </div>
                    <Button
                        //style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '15px',
                            marginTop: '15px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        {/* <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton> */}
                        <span>Refresh</span>
                    </Button>
                    <Button
                        //style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        style={{
                            background: 'linear-gradient(to right, #98DED9,#98DED9)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '15px'
                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >

                        <span>Excel</span>
                    </Button>


                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>


            <div
                className="w-full mb-5 flex"
                style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}
            >
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B', width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                {[
                                    'Category',
                                    'Code',
                                    'Item',
                                    'Opening',
                                    'Purchase',
                                    'Purchase Return',
                                    'Sale',
                                    'Sale Return',
                                    'StockJournalQty',
                                    'Closing',
                                    'Purchase Rate',
                                    'MRP',
                                    'GST%',
                                    'HSN Code',
                                ].map((header) => (
                                    <TableCell
                                        key={header}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            fontWeight: 'bolder',
                                            fontSize: '14px',
                                            padding: '7px',
                                            color: 'whitesmoke',
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        
                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => {
                                const isDuplicateCategory = index > 0 && data.CategoryName === filteredDataItem[index - 1].CategoryName;

                                return (
                                    <TableRow
                                        key={data.id}
                                        className="highlighted-row"
                                        sx={{
                                            padding: '7px',
                                            height: '52px',
                                            backgroundColor: 'transparent',
                                        }}
                                    >
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid black',
                                                color: 'black',
                                                fontWeight: 'bolder',
                                                padding: '5px',
                                                fontSize: '12px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {!isDuplicateCategory ? data.CategoryName : ''} {/* Hide duplicate */}
                                        </TableCell>
                                        {[data.Code, data.Name, data.OpeningQty, data.PurchaseQty, data.PurchaseReturnQty, data.SaleQty, data.SaleReturnQty, data.StockJournalQty, data.ClosingQty, data.PurchaseRate.toFixed(2), data.MRP.toFixed(2), data.GSTRate, data.HSNCode].map((value, i) => (
                                            <TableCell
                                                key={i}
                                                sx={{
                                                    borderBottom: '1px solid black',
                                                    color: 'black',
                                                    fontWeight: 'bolder',
                                                    padding: '5px',
                                                    fontSize: '12px',
                                                    textAlign: i >= 3 ? 'center' : 'left',
                                                }}
                                            >
                                                {value}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}

                            <TableRow
                                className="highlighted-row"
                                sx={{ padding: '7px', height: '52px', backgroundColor: 'teal' }}
                            >
                                <TableCell colSpan={3} />
                                <TableCell
                                    sx={{
                                        borderBottom: '1px solid #F5F5F5',
                                        color: 'whitesmoke',
                                        fontWeight: 'bolder',
                                        padding: '5px',
                                        fontSize: '12px',
                                        textAlign: 'left',
                                    }}
                                >
                                    {totalopbal}
                                </TableCell>
                                {[totalp, totalprtn, totals, totalsrtn, totalrpl, totalcls].map((total, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            color: 'whitesmoke',
                                            fontWeight: 'bolder',
                                            padding: '5px',
                                            fontSize: '12px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {total}
                                    </TableCell>
                                ))}
                                <TableCell colSpan={2} />
                                <TableCell colSpan={3} />
                            </TableRow>
                        </TableBody>

                    </Table>
                </TableContainer>

            </div>

        </div>
    );
}

export default Stock;
